import api from './api';
import requester from './requester';

const loggingService = {
    createLoggingRecord: (type, data) => requester(api.logging(type)).create(data),
};

export default loggingService;
